import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: 'https://wp.paperstac.com/index.php?graphql',
  cache: new InMemoryCache(),
});

export default client;
